import {shape, number, string, any, oneOf, arrayOf} from 'prop-types';

export default shape({
  mediaId: string,
  vehicle: string,
  metadata: shape({
    link: shape({
      type: oneOf(['dsn', 'vin']),
      value: any
    }),
    triggerType: string,
    remainingDrivingTime: any,
    remainingOnDutyTime: any
  }),
  captures: arrayOf(
    shape({
      durationSeconds: number,
      startDate: any,
      endDate: any
    })
  )
});
